/* eslint-disable @typescript-eslint/naming-convention */
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import type { LinkedImageList, RegulatoryFooter, SiteFooter } from '@ps/web-martech-cms-types';
import { TrackingCategory, TrackingContext } from '@ps/web-shared-analytics';
import React from 'react';
import { useSelector } from 'react-redux';

import { CMSHTML, CMSLinkedImageList, useCMSReference } from '@swf/cms';
import { select } from '@swf/core/store';

import styles from './CMSFooter.scss';
import FooterMenu from './components/FooterMenu/FooterMenu';
import Logos from './components/Logos/Logos';
import MachineDate from './components/MachineDate/MachineDate';
import RegulatoryFooterES from './components/RegulatoryFooterES/RegulatoryFooterES';
import RegulatoryFooterUK from './components/RegulatoryFooterUK/RegulatoryFooterUK';

const CMSFooter: React.FC<SiteFooter> = ({
  menu,
  logos,
  copyright,
  social_media,
  regulatory_footer
}) => {
  const site = useSelector(select.cms.getSiteId);
  const isMobile = useSelector(select.device.isMobile);
  const footerDateTimeFlag = useFeature(FeatureFlag.FooterDateTime);
  const isSportsSelfExcluded = useSelector(select.account.isSportsSelfExcluded);
  const isSportsEmbedded = useSelector(select.sports.isSportsEmbedded);
  const socialMedia = useCMSReference<LinkedImageList>(social_media[0]);

  return (
    <TrackingContext.Provider
      value={{
        category: TrackingCategory.Stars,
        widget: { widgetName: 'CMS Footer Widget', widgetId: 'cms-footer-widget' }
      }}
    >
      <footer className={styles.footer} role="contentinfo">
        {!!menu.length && !isSportsSelfExcluded && !isSportsEmbedded && (
          <div className={styles.footerNavs}>
            {menu.map((subMenu, i) => (
              <FooterMenu key={i} {...subMenu} />
            ))}
          </div>
        )}
        {!!logos.length && <Logos logos={logos} />}
        {site === Sites.SPA && regulatory_footer?.length && (
          <RegulatoryFooterES regulatory_footer={regulatory_footer as RegulatoryFooter[]} />
        )}

        {isMobile && site === Sites.UK && regulatory_footer?.length && (
          <RegulatoryFooterUK regulatory_footer={regulatory_footer as RegulatoryFooter[]} />
        )}
        {!!(copyright || socialMedia) && (
          <div className={styles.footerBottom}>
            <div className={styles.footerBottomInner}>
              {!!copyright && (
                <CMSHTML
                  content={copyright}
                  className={styles.copyrightText}
                  enableHideOnMobile={isSportsEmbedded}
                />
              )}
              {socialMedia && <CMSLinkedImageList {...socialMedia} isFooter type="Social Media" />}
            </div>
          </div>
        )}
        {footerDateTimeFlag && <MachineDate />}
      </footer>
    </TrackingContext.Provider>
  );
};

export default CMSFooter;
